import type { ReactNode } from "react";
import { SidebarInset, SidebarProvider } from "@/components/layout/Sidebar/sidebar";

type PanelShellProps = {
  children: ReactNode;
  sidebar: ReactNode;
  topbar: ReactNode;
  sidebarCollapsed: boolean;
  onSidebarCollapsedChange: (collapsed: boolean) => void;
};

/** Shared authenticated application frame. Feature pages only render its content. */
export function PanelShell({
  children,
  sidebar,
  topbar,
  sidebarCollapsed,
  onSidebarCollapsedChange,
}: PanelShellProps) {
  return (
    <SidebarProvider open={!sidebarCollapsed} onOpenChange={(open) => onSidebarCollapsedChange(!open)}>
      {sidebar}
      <SidebarInset>
        {topbar}
        {children}
      </SidebarInset>
    </SidebarProvider>
  );
}
